import { validatePath } from './pathUtils'

export function decodeDataUrl(dataUrl: string): { bytes: Uint8Array; mime: string } | null {
    const match = dataUrl.match(/^data:([^;]+);base64,(.+)$/)
    if (!match) return null

    const mime = match[1]
    const base64 = match[2]
    try {
        const binary = atob(base64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i += 1) {
            bytes[i] = binary.charCodeAt(i)
        }
        return { bytes, mime }
    } catch {
        return null
    }
}

export async function materializeGeneratedImageDataUrl(
    dataUrl: string,
    options: {
        sessionDir: string
        counter: number
        writeBytes: (path: string, bytes: Uint8Array) => void | Promise<void>
        now?: () => number
    },
): Promise<string | null> {
    const parsed = decodeDataUrl(dataUrl)
    if (!parsed) return null

    const timestamp = (options.now ?? Date.now)()
    const filename = `gen-${options.counter}-${timestamp}.${mimeToExtension(parsed.mime)}`
    const savedPath = validatePath(`${options.sessionDir}/${filename}`)

    try {
        await Promise.resolve(options.writeBytes(savedPath, parsed.bytes))
        return savedPath
    } catch {
        return null
    }
}

function mimeToExtension(mime: string): string {
    const extMap: Record<string, string> = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
    }
    return extMap[mime] ?? 'png'
}
